
import VolumeMute from "../../../assets/filled/VolumeMute.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function VolumeMuteIcon({ className, dataTestid = "VolumeMuteIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <VolumeMute data-testid={dataTestid} className={classes} {...rest} />
  );
}
